import React from "react";
import PropTypes from "prop-types";

const FaceSignDisabled = (props) => {
  const { className, style } = props;
  return (
    <svg
      className={className}
      style={style}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.4">
        <path
          d="M1.59991 7.56591C1.59991 4.27105 4.27092 1.60004 7.56579 1.60004H11.3623V4.85415H7.56579C6.06813 4.85415 4.85403 6.06824 4.85403 7.56591V11.3624H1.59991V7.56591Z"
          fill="url(#paint0_linear_1697:45291)"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M15.701 5.9389C10.9085 5.9389 7.02338 9.824 7.02338 14.6165V15.8998C7.02338 20.4561 10.1751 24.4065 14.6177 25.4184L15.2192 25.5554C15.5364 25.6277 15.8657 25.6277 16.1828 25.5554L16.7844 25.4184C21.2269 24.4065 24.3787 20.4561 24.3787 15.8998V14.6165C24.3787 9.82401 20.4935 5.9389 15.701 5.9389ZM21.1245 15.8998V14.6165C21.1245 11.6212 18.6963 9.19302 15.701 9.19302C12.7056 9.19302 10.2775 11.6212 10.2775 14.6165V15.8998C10.2775 18.9374 12.3787 21.571 15.3403 22.2455L15.701 22.3277L16.0617 22.2455C19.0234 21.571 21.1245 18.9374 21.1245 15.8998Z"
          fill="url(#paint1_linear_1697:45291)"
        />
        <path
          d="M23.8364 1.60004C27.1312 1.60004 29.8023 4.27105 29.8023 7.56591V11.3624H26.5482V7.56591C26.5482 6.06824 25.3341 4.85415 23.8364 4.85415H20.04V1.60004H23.8364Z"
          fill="url(#paint2_linear_1697:45291)"
        />
        <path
          d="M29.8023 23.8364C29.8023 27.1312 27.1312 29.8023 23.8364 29.8023H20.04V26.5481H23.8364C25.3341 26.5481 26.5482 25.334 26.5482 23.8364V20.0399H29.8023V23.8364Z"
          fill="url(#paint3_linear_1697:45291)"
        />
        <path
          d="M7.56573 26.5481H11.3622V29.8023H7.56572C4.27086 29.8022 1.59985 27.1312 1.59985 23.8364V20.0399H4.85396V23.8364C4.85396 25.334 6.06806 26.5481 7.56573 26.5481Z"
          fill="url(#paint4_linear_1697:45291)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_1697:45291"
          x1="8.31153"
          y1="11.9256"
          x2="3.51064"
          y2="5.36552"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#4AEAEB" />
          <stop offset="1" stop-color="#4871F0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1697:45291"
          x1="18.9551"
          y1="26.7445"
          x2="8.98114"
          y2="14.7198"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#4AEAEB" />
          <stop offset="1" stop-color="#4871F0" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_1697:45291"
          x1="26.7516"
          y1="11.9256"
          x2="21.9507"
          y2="5.36554"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#4AEAEB" />
          <stop offset="1" stop-color="#4871F0" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_1697:45291"
          x1="26.7516"
          y1="30.3655"
          x2="21.9506"
          y2="23.8054"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#4AEAEB" />
          <stop offset="1" stop-color="#4871F0" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_1697:45291"
          x1="8.31147"
          y1="30.3655"
          x2="3.51054"
          y2="23.8054"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#4AEAEB" />
          <stop offset="1" stop-color="#4871F0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

FaceSignDisabled.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
};

FaceSignDisabled.defaultProps = {
  className: undefined,
  style: undefined,
};

export default FaceSignDisabled;
